
export default {
	getModuleType: (state) => (type) => {

		return state.moduleType
    },
	getModuleSubType: (state) => (type) => {

		return state.moduleSubType
    },

    getSettingListPageType: (state) => (type) => {

		return state.page
    },

    getRequestPayload: (state) => (type) => {

		return state.payload
    },

	getSettingAllFilter: (state) => (type) => {

		return state.filters
    },
	
	getSettingFilter: (state) => (type, filterName ) => {
		if ( ! state.filters ) {

			return null
		}

		const filter = state.filters.find( ( cv ) => cv.name === filterName )

		return filter || null
    },

	getSettingAllFilterOptions: (state) => (type) => {
		return state.options
    },
	getFilterTags: (state) => (type) => {
		return state.filterTags
    },
    

    getSettingFilterOptions: (state) => (type, filterName ) => {

		// console.log('state.options', type, filterName)

		if ( ! state.options || ! state.options[ filterName ] ) {

			return null
		}

		return state.options[ filterName ]
    },
	
	getSettingFilterVisibility: (state) => (type, filterName ) => {
		if (!state.filters) {
			return false
		}

		const filter = state.filters.find( ( cv ) => cv.name === filterName )

		return filter && filter.isOpen ? true : false
    },



    getSettingListingResult: (state) => ( ) => {
    	return state.results.data
    },

    getSettingListingCurrentPage: (state) => ( ) => {
    	return state.results.current_page
    },

    getSettingListingNextPageUrl: (state) => ( ) => {
   
       	return state.results.next_page_url
    },

    getSettingShowSkeleton: (state) => ( ) => {
   
       	return state.skeleton
    },
	getSkeletonShowMore: (state) => ( ) => {
   
		return state.showMoreSkeleton
 	},

    getSettingListingResultCount: (state) => ( ) => {
   		
   		if (state.results.total) {

   			return state.results.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
   		}
       	return state.results.total
    },

    getSettingListingCompareListCount: (state) => ( ) => {
   		
   		if (state.compare_list_count) {

   			return state.compare_list_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
   		}
       	return state.compare_list_count
    },

    getDiamondCompareListItems: (state) => ( ) => {
   		
   		return state.compare_list
    },

	getListingError: (state) => ( ) => {
   		
			return state.error
	}

}





















// export default function useGetter( state ){

// 	const getModuleType =  (type) => state.moduleType
// 	const getModuleSubType =  (type) => state.moduleSubType
// 	const getSettingListPageType =  (type) => state.page
// 	const getRequestPayload =  (type) => state.payload
// 	const getSettingAllFilter =  (type) => state.filters
// 	const getSettingFilter =  (type, filterName) => {
// 		if (!state.filters) {
// 			return null
// 		}
// 		const filter = state.filters.find((cv) => cv.name === filterName)
// 		return filter || null
// 	}
// 	const getSettingAllFilterOptions =  (type) => state.options
// 	const getSettingFilterOptions =  (type, filterName) => {
// 		if (!state.options || !state.options[filterName]) {
// 			return null
// 		}
// 		return state.options[filterName]
// 	}
// 	const getSettingFilterVisibility =  (type, filterName) => {
// 		if (!state.filters) {
// 			return false
// 		}
// 		const filter = state.filters.find((cv) => cv.name === filterName)
// 		return filter && filter.isOpen ? true : false
// 	}
// 	const getSettingListingResult =  () => state.results.data
// 	const getSettingListingCurrentPage =  () => state.results.current_page
// 	const getSettingListingNextPageUrl =  () => state.results.next_page_url
// 	const getSettingShowSkeleton =  () => state.skeleton
// 	const getSkeletonShowMore =  () => state.showMoreSkeleton
// 	const getSettingListingResultCount =  () => {
// 		if (state.results.total) {
// 			return state.results.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
// 		}
// 		return state.results.total
// 	}
// 	const getSettingListingCompareListCount =  () => {
// 		if (state.compare_list_count) {
// 			return state.compare_list_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
// 		}
// 		return state.compare_list_count
// 	}
// 	const getDiamondCompareListItems =  () => state.compare_list
// 	const getListingError =  () => state.error

// 	return {
// 		getModuleType,
// 		getModuleSubType,
// 		getSettingListPageType,
// 		getRequestPayload,
// 		getSettingAllFilter,
// 		getSettingFilter,
// 		getSettingAllFilterOptions,
// 		getSettingFilterOptions,
// 		getSettingFilterVisibility,
// 		getSettingListingResult,
// 		getSettingListingCurrentPage,
// 		getSettingListingNextPageUrl,
// 		getSettingShowSkeleton,
// 		getSkeletonShowMore,
// 		getSettingListingResultCount,
// 		getSettingListingCompareListCount,
// 		getDiamondCompareListItems,
// 		getListingError

// 	}
// }